var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('b-sidebar',{attrs:{"type":"is-light","fullheight":_vm.fullheight,"fullwidth":_vm.fullwidth,"overlay":_vm.overlay,"right":_vm.right,"mobile":"hide"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('MenuItens'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }